import { useContext } from 'react';
import { ClassroomsContext } from './context';

export default function useClassrooms() {
  const context = useContext(ClassroomsContext);
  if (context === undefined) {
    throw new Error('useClassrooms must be used within a ClassroomsProvider');
  }
  return context;
}
